module.exports = __webpack_public_path__ + "static/img/share_pop.607f866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/share_pop.png
// module id = rSM7
// module chunks = 1